import { Provider } from '@angular/core'
import { MbCartMigrationService } from '../services/mb-cart-migration.service'
import { MbCartMigrationFacade } from './mb-cart-migration.facade'

export const mbFacadeProviders: Provider[] = [
  {
    provide: MbCartMigrationFacade,
    useExisting: MbCartMigrationService
  },
]
